import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';
// import Utils from '@/components/shared/helpers/Utils.js';

const state = {
  usuarios: []
};

const getters = {
  [types.ALL_USUARIOS]: state => {
    return state.usuarios;
  }
};

const mutations = {
  [types.MUTATE_ALL_USUARIOS]: (state, payload) => {
    state.usuarios = payload;
  }
};

const actions = {
  [types.ACTION_FILTER_USUARIOS]: ({ commit }, payload) => {
    let request = {
      controller: '/Authorization/' + process.env.VUE_APP_KEYCLOAK_CLIENTID + '/Search/' + payload,
      opts: {
        errorHandleRedirect: Boolean(false)
      }
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuitPlataforma', request)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_ALL_USUARIOS]: ({ commit }, payload) => {
    let request = { controller: '/CiudadUsuario/' + payload.idCiudad };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_USUARIOS, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },

  [types.ACTION_SAVE_USUARIO]: ({ commit, getters }, payload) => {
    let request = {
      controller: '/CiudadUsuario/' + payload.idCiudad + '/' + payload.idUsuario,
      filter: {},
      body: {}
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postSuit', request)
        .then(response => {
          // var items = Utils.ModifyArrayAfterSaveItem(getters[types.ALL_USUARIOS], payload.item);
          // commit(types.MUTATE_ALL_USUARIOS, items);
          // Message.showMessage('La usuario se ha añadido con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },

  [types.ACTION_DELETE_USUARIO]: ({ commit }, payload) => {
    let request = {
      controller: '/CiudadUsuario/' + payload.idCiudad + '/' + payload.idUsuario,
      filter: {}
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/deletes', request)
        .then(response => {
          // commit(types.MUTATE_ALL_USUARIOS, payload.items);
          // Message.showMessage('El usuario se ha eliminado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};
